export const list = (dispatch, apiClient) => apiClient
  .call({
    endpoint: 'location/list',
  })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'LOCATIONS_SET', locations: res.data });
    return res;
  });

export const create = (dispatch, apiClient, data) => apiClient
  .call({ endpoint: 'location/new', data })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'LOCATIONS_SET', locations: res.data });
    return res;
  });

export const remove = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'location/remove', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'LOCATIONS_SET', locations: res.data });
    return res;
  });

export const update = (dispatch, apiClient, id, changes) => apiClient
  .call({ endpoint: 'location/update', data: { id, changes } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'LOCATIONS_SET', locations: res.data });
    return res;
  });

export const get = (dispatch, apiClient, id) => apiClient
  .call({ endpoint: 'location/get', data: { id } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    dispatch({ type: 'LOCATIONS_SET', locations: res.data.location });
    dispatch({ type: 'STOCK_SET', payload: res.data.stock });
    dispatch({ type: 'RAW_MATERIAL_STOCK_SET', payload: res.data.rawMaterialStock });
    return res;
  });

export const updateArticle = (dispatch, apiClient, id, articleId, count = 0) => apiClient
  .call({ endpoint: 'location/updateArticle', data: { id, articleId, count } })
  .then(res => {
    if (res.status !== 200) {
      throw res;
    }
    // dispatch({ type: 'LOCATIONS_SET', locations: res.data.location });
    return res;
  });



// WEBPACK FOOTER //
// ./app/actions/locations.js